import StepTitle from './StepTitle';

const SignUpContainer = ({ closeSignUp, children }) => {
  return (
    <>
      <div className='flex flex-col justify-between p-6 md:mt-16 md:mx-auto md:p-0 md:h-auto md:max-w-3xl h-window bg-white relative md:top-1/4 overflow-y-auto md:overflow-y-hidden overflow-x-hidden z-20'>
        <div className='divide-y-2 divide-black divide-opacity-50 z-10 h-full'>
          <div>
            <div className='flex justify-between items-center'>
              <StepTitle stepTitleContent={'Create your account'} />
              <svg
                height='1em'
                viewBox='0 0 384 512'
                stroke='currentColor'
                fill='currentColor'
                className={
                  'h-5 w-5 text-dms-primary cursor-pointer hover:text-dms-light transition duration-300 ease-in-out'
                }
                onClick={closeSignUp}
              >
                <path d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z' />
              </svg>
            </div>
          </div>

          {children}
        </div>
      </div>
    </>
  );
};

export default SignUpContainer;
